// Meta Pixel utility functions

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const initMetaPixel = () => {
  // Check if already initialized
  if (window.fbq) return // Meta Pixel initialization code
  ;(function (f: any, b: any, e: any, v: any, n: any, t: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    // Safely append to head instead of inserting before first script
    b.head.appendChild(t)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', '1424056906028921')
  window.fbq('track', 'PageView')

  // Add noscript fallback image
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src =
    'https://www.facebook.com/tr?id=1424056906028921&ev=PageView&noscript=1'
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

export const trackAddToCart = () => {
  if (window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
